import React from "react";
import { Toaster } from "sonner";
import { LangProvider, useLang } from "../lib/lang-context";
import { ThemeProvider } from "../lib/theme-context";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ValueProps from "../components/ValueProps";
import Catalog from "../components/Catalog";
import Process from "../components/Process";
import Stories from "../components/Stories";
import About from "../components/About";
import Sectors from "../components/Sectors";
import Coverage from "../components/Coverage";
import Certifications from "../components/Certifications";
import Blog from "../components/Blog";
import FAQ from "../components/FAQ";
import QuoteForm from "../components/QuoteForm";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppFab from "../components/WhatsAppFab";
import ParallaxInterlude from "../components/ParallaxInterlude";
import SEO from "../components/SEO";

const Composition = () => {
  const { t } = useLang();
  return (
    <main>
      <Hero />

      <ValueProps />
      <Catalog />

      {/* Interlude 1 — VIDEO: hospital corridor with nurse */}
      <ParallaxInterlude
        testid="interlude-clinic"
        video="https://videos.pexels.com/video-files/6129925/6129925-hd_1920_1080_30fps.mp4"
        poster="https://images.pexels.com/videos/6129925/pexels-photo-6129925.jpeg?auto=compress&cs=tinysrgb&w=1920"
        eyebrow={t.interludes.clinic.eyebrow}
        title={t.interludes.clinic.title}
        body={t.interludes.clinic.body}
      />

      <Process />
      <Stories />
      <About />
      <Sectors />

      {/* Interlude 2 — VIDEO: doctors collaborating */}
      <ParallaxInterlude
        testid="interlude-borders"
        video="https://videos.pexels.com/video-files/6130022/6130022-hd_1920_1080_30fps.mp4"
        poster="https://images.pexels.com/videos/6130022/pexels-photo-6130022.jpeg?auto=compress&cs=tinysrgb&w=1920"
        eyebrow={t.interludes.borders.eyebrow}
        title={t.interludes.borders.title}
        body={t.interludes.borders.body}
        align="right"
      />

      <Coverage />

      <Certifications />
      <Blog />
      <FAQ />
      <QuoteForm />
      <Contact />
    </main>
  );
};

export default function HomePage() {
  return (
    <ThemeProvider>
      <LangProvider>
        <SEO
          title="ICOR"
          description="Distribuidor mexicano de insumos médicos desechables certificados para hospitales, clínicas y consultorios. Cobertura en México, Estados Unidos y Canadá con trazabilidad y cadena fría."
          canonical="https://icor.mx/"
          image="https://icor.mx/icor-logo-512.png"
        />
        <div
          className="min-h-screen bg-white dark:bg-zinc-950 transition-colors"
          data-testid="home-page"
        >
          <Header />
          <Composition />
          <Footer />
          <WhatsAppFab />
          <Toaster
            position="top-right"
            richColors
            toastOptions={{
              style: { fontFamily: "Manrope, sans-serif", borderRadius: 4 },
            }}
          />
        </div>
      </LangProvider>
    </ThemeProvider>
  );
}
